import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CreateOrderResponseDto } from "types/order.types"

type Order = {
  orderDetail: CreateOrderResponseDto | null;
  selectedIpgId: number | null;
}

const initialState = {
  orderDetail: null,
  selectedIpgId: null
} as Order

export const order = createSlice({
  name: "order",
  initialState: initialState,
  reducers: {
    updateOrderInfo: (state, action: PayloadAction<CreateOrderResponseDto>) => {
      state.orderDetail = action.payload
    },
    updateSelectedIpgId: (state, action: PayloadAction<number | null>) => {
      state.selectedIpgId = action.payload
    },
    resetOrderSlice: () => structuredClone(initialState)
  }
})

export const {
  updateOrderInfo,
  updateSelectedIpgId,
  resetOrderSlice
} = order.actions

export default order.reducer
